import { cn } from "@/utils/cn";
import React from "react";

interface SafePinProps {
	className?: string;
	children: React.ReactNode;
}

/**
 * A styled pin for map markers, with error handling and animation support.
 * Automatically adjusts size based on map zoom level.
 */
export const SafePin = React.forwardRef<HTMLDivElement, SafePinProps>(function SafePin({ className, children }, ref) {
	return (
		<div
			ref={ref}
			className={cn(
				`marker flex items-center justify-center rounded-full font-bold text-xs cursor-pointer shadow-md bg-primary-500 border-1 border-primary transform origin-center opacity-90`,
				className,
			)}
		>
			{children}
		</div>
	);
});
